import { render, staticRenderFns } from "./PolicyCreate.vue?vue&type=template&id=2c56bc33&scoped=true&"
import script from "./PolicyCreate.vue?vue&type=script&lang=js&"
export * from "./PolicyCreate.vue?vue&type=script&lang=js&"
import style0 from "./PolicyCreate.vue?vue&type=style&index=0&id=2c56bc33&prod&lang=css&"
import style1 from "./PolicyCreate.vue?vue&type=style&index=1&id=2c56bc33&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c56bc33",
  null
  
)

export default component.exports